'use client';

import { apiSwagger } from '@/shared/api';
import { NEXT_PROD } from '@/shared/envs';
import etaLoader from '@/lib/EtaLoader';
import { useEffect } from 'react';

// Extend Window interface to include analytics properties
declare global {
  interface Window {
    dataLayer: any[];
    ym: any;
    adsbygoogle: any[];
  }
}

export default function ServicesLoader() {
  useEffect(() => {
    // Handle geolocation, logging, and ads in one flow
    handleGeolocationAndAnalytics();
    // GTM is now injected in <head> via layout.tsx

    if (typeof window !== 'undefined' && etaLoader) {
      etaLoader.setStage('startingUp', 0.7);
    }
  }, []);

  const loadGoogleAds = () => {
    // Check if script already exists
    if (document.querySelector('script[src*="pagead2.googlesyndication.com"]')) {
      console.log('[Ads] Google Ads script already loaded');
      return;
    }

    // Load Google Ads script
    const script = document.createElement('script');
    script.src = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-3485580809461643';
    script.async = true;
    script.crossOrigin = 'anonymous';
    document.head.appendChild(script);
    console.log('[Ads] Google Ads script loaded');
  };

  const handleGeolocationAndAnalytics = async () => {
    try {
      let country: string | undefined = '';

      // Log visitor with geolocation data using new backend API
      try {
        await apiSwagger.iplogging.iploggingCreate();
        const logResponse = await fetch('/api/log-visitor', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: ''
        });

        if (logResponse.ok) {
          const logData = await logResponse.json();

          if (logData.ipInfo && logData.ipInfo.country) {
            country = logData.ipInfo.country;
            console.log('[IpLogging] Get country from response:', country);

            // Store country in localStorage for client-side access
            if (typeof window !== 'undefined' && country) {
              localStorage.setItem('userCountry', country);
              console.log('[IpLogging] Stored country in localStorage:', country);

              // Load Google Ads only if user is NOT from Russia AND we are on production
              if (country !== 'RU' && NEXT_PROD === 'true') {
                loadGoogleAds();
              } else if (country === 'RU') {
                console.log('[Ads] User is from Russia - Google Ads will NOT be loaded');
              } else if (NEXT_PROD !== 'true') {
                console.log('[Ads] Not on production - Google Ads will NOT be loaded');
              }
            }
          }
        } else {
          console.error('[IpLogging] Failed to log visitor data:', logResponse.status, logResponse.statusText);
          // On error, load ads by default (opt-in approach) - but only on production
          if (typeof window !== 'undefined' && NEXT_PROD === 'true') {
            loadGoogleAds();
          }
        }
      } catch (error) {
        console.error('[IpLogging] Failed to log visitor:', error);
        // On error, load ads by default (opt-in approach) - but only on production
        if (typeof window !== 'undefined' && NEXT_PROD === 'true') {
          loadGoogleAds();
        }
      }

    } catch (err) {
      throw err;
    }
    if (typeof window !== 'undefined' && etaLoader) {
      etaLoader.setStage('startingUp', 0.9);
    }
  };

  return null; // This component doesn't render anything
} 